import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import Input from '@zvuk-b2b/react-uikit/ui/Input';
import TextArea from '@zvuk-b2b/react-uikit/ui/TextArea';

import { PromoRollSynthVoiceType, PromoRollSynthBackgroundType } from '@entities/PromoRollSynthJob/model';

import { getFieldErrorText } from '../../model/getFieldErrorText';
import VoiceSelect from '../VoiceSelect/VoiceSelect';
import BackgroundSelect from '../BackgroundSelect/BackgroundSelect';
import { TEXTS } from '../PromoRollSynthModal/texts';
import styles from './PromoRollSynthForm.module.scss';

export type PromoRollSynthFormValues = {
  title: string;
  text: string;
  voiceId: string;
  backgroundId: string;
};

type Props = {
  control: Control<PromoRollSynthFormValues>;
  voices: PromoRollSynthVoiceType[];
  backgrounds: PromoRollSynthBackgroundType[];
  maxTitleLength: number;
  maxTextLength: number;
};

const PromoRollSynthForm: FC<Props> = ({ control, voices, backgrounds, maxTitleLength, maxTextLength }) => (
  <>
    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{TEXTS.SECTION_PARAMETERS_TITLE}</h3>

      <Controller
        control={control}
        name="title"
        rules={{ required: true, maxLength: maxTitleLength }}
        render={({ field, fieldState }) => (
          <Input
            elementId="promo_title"
            label={TEXTS.FIELD_TITLE_LABEL}
            placeholder={TEXTS.FIELD_TITLE_PLACEHOLDER}
            value={field.value}
            maxLength={maxTitleLength}
            error={getFieldErrorText(fieldState.error, maxTitleLength)}
            onChange={(value) => field.onChange(value)}
          />
        )}
      />

      <div>
        <Controller
          control={control}
          name="text"
          rules={{ required: true, maxLength: maxTextLength }}
          render={({ field, fieldState }) => (
            <>
              <TextArea
                elementId="promo_text"
                label={TEXTS.FIELD_TEXT_LABEL}
                placeholder={TEXTS.FIELD_TEXT_PLACEHOLDER}
                rows={3}
                value={field.value}
                maxLength={maxTextLength}
                error={getFieldErrorText(fieldState.error, maxTextLength)}
                onChange={(value) => field.onChange(value)}
              />
              {!fieldState.error && <span className={styles.hint}>{TEXTS.TEXT_MAX_LENGTH_HINT(maxTextLength)}</span>}
            </>
          )}
        />
      </div>
    </div>

    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{TEXTS.SECTION_VOICE_TITLE}</h3>

      <Controller
        control={control}
        name="voiceId"
        rules={{ required: true }}
        render={({ field }) => (
          <VoiceSelect
            value={field.value}
            options={voices}
            onChange={field.onChange}
          />
        )}
      />
    </div>

    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{TEXTS.SECTION_BACKGROUND_TITLE}</h3>

      <Controller
        control={control}
        name="backgroundId"
        rules={{ required: true }}
        render={({ field }) => (
          <BackgroundSelect
            value={field.value}
            options={backgrounds}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  </>
);

export default PromoRollSynthForm;
